import React, { FC } from 'react'
import { createPortal } from 'react-dom'

interface Props {
  target: string
  children: React.ReactNode
}

export const Portal: FC<Props> = ({ target, children }) => {
	return createPortal(children, document.getElementById(target)!)
}
